<template>
  <b-container>
    <spinner />
    <div v-if="!isLoading">
      <h1 v-translate>Manage Aper</h1>
      <div class="row">
        <div class="col-md-3">
          <company-navigation />
        </div>
        <div class="col-md-9 personal-info">
          <h2>Aper - <translate>Configuration Panel</translate> </h2>
          <form @submit.stop.prevent="setAperIntegration" >
            <div class="form-group col-12" >
              <label for="reference">ID Store</label>
              <b-form-input id="store" name="store" v-model="integration.externalStoreId" class="col-12" required/>
            </div>

            <div class="form-group col-12" >
              <label for="reference">ID seller</label>
              <b-form-input id="seller" name="seller" v-model="integration.externalUserId" class="col-12" required />
            </div>
            <h4 class="form-group col-12 mt-4 mb-4"><translate>Shipping Types</translate></h4>
            <div class="form-group col-md-12"  v-for="(settings, index) in integration.metadata" :key="settings + index" >
              <b-row>
                <div class="form-group col-5" >
                  <label for="reference" v-translate>Shipping Type</label>
                  <b-form-select v-model="settings.type" :options="availableTypes" required></b-form-select>
                </div>

                <div class="form-group col-5" >
                  <label for="reference">ID Delivery Type</label>
                  <b-form-input id="store" name="store" v-model="settings.id" class="col-12" required/>
                </div>

                <div class="form-group col-2" >
                  <button type="button" class="btn btn-primary mt-3"  @click="addSetting">+</button>
                  <button type="button" class="btn btn-danger mt-3"  @click="removeSetting(index)" >-</button>
                </div>
              </b-row>
            </div>

            <div class="text-right mt-5">
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                v-translate
              >Save</b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { FETCH_PROFILE } from '@/store/actions.type'
import CompanyNavigation from '../components/CompanyNavigation.vue'

export default {
  name: 'AperIntegrationPage',
  components: {
    Spinner,
    CompanyNavigation
  },
  data() {
    return {
      dataChanged: false,
      availableTypes: ['regular', 'express', 'next_day'],
      integration: {
        companyId: '',
        userId: '',
        externalStoreId: '',
        externalUserId: '',
        metadata: [{ id: '', type: '' }]
      },
      application: null,
      platformSlug: 'aper',
      platforms: []
    }
  },
  props: { type: { type: String, default: 'ongoing' } },
  computed: {
    ...mapGetters(['user', 'isLoading'])
  },
  async beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
    this.getPlatforms()
  },
  mounted() {
    this.$store.state.dashboard.isLoading = true
  },
  methods: {
    getPlatforms() {
      this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
        .then(response => {
          this.platforms = response.body.data
          this.getAperIntegration()
        })
    },
    addSetting() { this.integration.metadata.push({}) },
    removeSetting(index) { this.integration.metadata.splice(index, 1) },
    async generateApplication() {
      const { data: response } = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      const thePlatform = platforms.find(x => x.slug === this.platformSlug)
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const { data } = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return data
    },
    getPreviousApplication(thePlatform) {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform.id === thePlatform.id && params.get('userId') === String(this.user.id)) {
          return app
        }
      }
      return null
    },
    async getAperIntegration() {
      const thePlatform = this.platforms.find(x => x.slug === this.platformSlug)
      this.application = this.getPreviousApplication(thePlatform)
      if (!this.application) return
      const path = `${this.$appConfig.integrations.ecommerce.baseUrl}${this.platformSlug}/authenticate-user?appId=${this.application.id}`
      const { data } = await this.$http.get(path, { before: this.changeAuth })
      this.integration = data
    },
    changeAuth(req) {
      req.headers.set('x-api-key', this.$appConfig.integrations.ecommerce.header)
      return req.headers.set('Authorization', this.application.key)
    },
    async setAperIntegration() {
      if (!this.isValidCompany()) return false
      if (!this.application) {
        this.application = await this.generateApplication()
      }
      const body = {
        ...this.integration,
        appId: this.application.id,
        appKey: this.application.key,
        companyId: String(this.user.company_id),
        userId: this.user.id
      }
      const path = this.$appConfig.integrations.ecommerce.baseUrl + this.platformSlug + '/authenticate'
      const headers = { 'Access-Control-Allow-Origin': '*', 'x-api-key': this.$appConfig.integrations.ecommerce.header }
      let message = {}
      try {
        await this.$http.post(path, body, { headers })
        message = {
          title: this.$gettext('Success'),
          type: 'success',
          customCloseBtnText: this.$gettext('Close')
        }
      } catch (error) {
        message = {
          title: 'ERROR',
          message: JSON.stringify(error.body),
          type: 'error',
          customCloseBtnText: this.$gettext('Close')
        }
      }
      this.$root.$children[0].$refs.simplert.openSimplert(message)
    },
    isValidCompany() {
      const isValid = this.user && this.user.company_id
      if (isValid) return true
      const obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), { helpEmail: this.helpEmail }),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
      return false
    }
  }
}
</script>
